module.exports = __webpack_public_path__ + "img/close_button.dbf8657b.png";